import React from 'react';
import Link from 'app/common/components/Link';

import { Surface } from 'app/developer-v3/teams/team-technical-support-operations/get-help';

type SubmittedProps = {
  size: 'small' | 'medium' | 'large';
};

const Submitted = ({ size }: SubmittedProps) => (
  <Surface size={size} title="Thank you!">
    <p>
      We’ve received your message and will get back to you soon. Until then,
      feel free to browse our{' '}
      <Link
        href="https://community.zapier.com/developer-discussion-13"
        target="_blank"
      >
        Community
      </Link>{' '}
      or{' '}
      <Link href="https://help.zapier.com/hc/en-us" target="_blank">
        Help Center
      </Link>
      .
    </p>
  </Surface>
);

export default Submitted;
